import { CalculationResult } from "./CalculationResult";
import { ChangeType } from "./ChangeType";
import { CostData } from "./CostData";

export abstract class BaseFormula
{
    checkLength(data: CostData[], min_length: number, show_new_cost: boolean): CalculationResult | null
    {
        if (data.length < min_length)
            return {
                value: show_new_cost ? true : null,
                reason: `Not enough data to calculate.`,
                values: { required: `atleast ${min_length}`, provided: data.length }
            };
        return null;
    }
    checkChnage(change: ChangeType, difference: number, values: { [name: string]: any }): CalculationResult | null
    {
        if (change == ChangeType.Increased)
            if (difference < 0)
                return {
                    value: null,
                    reason: `Chnage Type is set to 'If Increased', but the difference is negative.`,
                    values
                };

        if (change == ChangeType.Decreased)
            if (difference > 0)
                return {
                    value: null,
                    reason: `Chnage Type is set to 'If Decreased', but the difference is positive.`,
                    values
                };

        return null;
    }
    protected static median(arr: number[]): number
    {
        if (arr.length === 0)
            return NaN;

        const sorted = [...arr].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);

        if (sorted.length % 2 === 0)
            return (sorted[mid - 1] + sorted[mid]) / 2;
        return sorted[mid];
    }
    abstract evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { [name: string]: number }, show_new_cost: boolean): CalculationResult;
}